import { motion } from 'framer-motion';
import { Separator } from '@/components/ui/separator';

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.25, 0.4, 0.25, 1] } }
};

const fadeRight = {
  hidden: { opacity: 0, x: 30 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.7, ease: [0.25, 0.4, 0.25, 1] } }
};

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 lg:py-32 bg-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={fadeUp}
          >
            <p className="font-body text-[#B8102E] text-xs tracking-[0.3em] uppercase mb-4">
              Our Philosophy
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl font-bold text-white tracking-tight mb-6">
              Built Like a Utility Player.{' '}
              <span className="text-[#B8102E]">Operates Like a Platform.</span>
            </h2>
            <Separator className="bg-[#2A2A2A] mb-6 w-20" />
            <div className="space-y-4 font-body text-[#A3A3A3] leading-relaxed">
              <p>
                Cole Utilities adapts across industries and project types, integrating
                seamlessly into existing teams or leading delivery from the ground up.
              </p>
              <p>
                We bridge the critical gap between strategy and execution — transforming
                government mandates into measurable outcomes with precision and speed.
              </p>
              <blockquote className="text-white/90 border-l-2 border-[#B8102E] pl-4 italic mt-6">
                "Just like a utility player can play any position on the field, Cole
                Utilities steps into any phase of your program lifecycle."
              </blockquote>
            </div>
          </motion.div>

          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={fadeRight}
            className="relative"
          >
            <div className="relative rounded-lg overflow-hidden border border-[#2A2A2A]">
              <img
                src="https://images.unsplash.com/photo-1529400971008-f566de0e6dfc?w=800&auto=format&fit=crop&q=80"
                alt="Strategic planning and execution"
                className="w-full h-80 lg:h-[420px] object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/30 to-transparent" />
            </div>
            <div className="absolute -bottom-3 -left-3 w-24 h-24 border-l-2 border-b-2 border-[#B8102E] rounded-bl-lg" />
            <div className="absolute -top-3 -right-3 w-16 h-16 border-t-2 border-r-2 border-[#B8102E]/40 rounded-tr-lg" />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
